'use strict';
// Shared by both bridge entry points and the browser bundle.
module.exports = { protocolVersion: 2 };
